// extracted by mini-css-extract-plugin
export default {"wrap":"fr-z","searchHeaderWrap":"gr-z","melodyCategory":"hr-z","fullWidth":"ir-z","items":"jr-z","featureCss":"kr-z","disabled":"lr-z","imgCss":"mr-z"};